import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';

import { IPageProps } from '@folx-types/flow-steps';

import BillPayRedirect, { IBillPayRedirectPageContent } from './BillPayRedirect.component';

interface IBillPayRedirectPageProps extends IPageProps {}

const BillPayRedirectPage: FC<IBillPayRedirectPageProps> = ({ path }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "bill-pay-page" }) {
				page_info
				back_button_label
				help_center_label
			}
		}
	`);

	const refinedContent: IBillPayRedirectPageContent = keysToCamel(
		pageContent
	) as IBillPayRedirectPageContent;

	return <BillPayRedirect pageContent={refinedContent} path={path} />;
};

export default BillPayRedirectPage;
